import React, { useState } from "react";
import styled from "styled-components";
import { Flex } from "rebass/styled-components";
import { getClipTitle } from "../../molecules/clip/utils";
import {
  TiktokShare,
  SnapchatShare,
  YTShare,
  InstagramShare,
} from "../../molecules/share/index";
import MobileShare from "../../molecules/share/mobile";
import { Error } from "../../atoms/form/error";
import DownloadMobile from "../../molecules/share/downloadMobile";
import DownloadCinema from "../../molecules/share/downloadCinema";
import Lottie from "lottie-react";
import loading from "../../../animations/loading.json";

const lottieStyle = {
  height: 28,
};

const ButtonText = styled.span`
  margin-left: 10px;
`;

export function PostContents({
  clip,
  classification,
  isMobile,
  aspectRatio = "9:16",
}) {
  classification = classification ? classification : "modalShare";
  const mobileData = clip.mobile?.find((x) => x.aspectRatio === aspectRatio);
  const mobileLink = mobileData?.clipLink;
  const [file, setFile] = useState({
    loading: false,
    mobile: false,
    file: null,
    error: false,
    hasFile: false,
  });

  async function createBlob(mobile) {
    const link = mobile && mobileLink ? mobileLink : clip.clipLink;
    try {
      let response = await fetch(
        `${process.env.REACT_APP_S3_CLIP_BUCKET}/${link}`
      );
      let data = await response.blob();
      let metadata = {
        type: "video/mp4",
      };

      let file = new File([data], "clip.mp4", metadata);

      return setFile({
        loading: false,
        file: file,
        error: false,
        hasFile: true,
      });
    } catch (e) {
      return setFile({
        loading: false,
        file: null,
        error: true,
        hasFile: false,
      });
    }
  }
  let commonProps = {
    classification: classification,
    title: getClipTitle(clip),
    size: "publish",
    clip: clip,
    clipLink: file.mobile ? mobileLink : clip.clipLink,
    file: file.file,
  };

  const FIFTY_MB = 50 * 1024 * 1000;

  return (
    <>
      <Flex flexDirection="column">
        {!file.hasFile || file.error ? (
          <>
            {file.error ? <Error>Something went wrong.</Error> : <></>}
            <Flex flexDirection="row" justifyContent="center">
              {file.loading ? (
                <>
                  <Lottie
                    justifyContent="center"
                    animationData={loading}
                    loop={true}
                    style={lottieStyle}
                  />
                </>
              ) : (
                <>
                  <Flex flexDirection="row" justifyContent="space-between">
                    <DownloadMobile
                      mb={2}
                      mr={3}
                      {...commonProps}
                      classification="modalShare"
                      disabled={!mobileLink}
                      title={mobileLink ? undefined : "Not available"}
                      onClick={() => {
                        setFile({ ...file, loading: true, mobile: true });
                        createBlob(true);
                      }}
                    ></DownloadMobile>
                    {clip.clipSizeBytes <= FIFTY_MB && !isMobile && (
                      <DownloadCinema
                        mb={2}
                        {...commonProps}
                        classification="modalShare"
                        onClick={() => {
                          setFile({
                            ...file,
                            loading: true,
                            mobile: false,
                            isPublished: true,
                          });
                          createBlob();
                        }}
                      ></DownloadCinema>
                    )}{" "}
                  </Flex>
                </>
              )}
            </Flex>
          </>
        ) : (
          <>
            <Flex flexDirection="row" justifyContent="space-between">
              <TiktokShare mb={3} mr={3} {...commonProps}>
                <ButtonText>TikTok</ButtonText>
              </TiktokShare>

              <SnapchatShare mb={3} {...commonProps}>
                <ButtonText>Snapchat</ButtonText>
              </SnapchatShare>
            </Flex>
            <Flex flexDirection="row" justifyContent="space-between">
              <YTShare mb={3} mr={3} {...commonProps}>
                <ButtonText>YouTube</ButtonText>
              </YTShare>
              <InstagramShare mb={3} {...commonProps}>
                <ButtonText>Instagram</ButtonText>
              </InstagramShare>
            </Flex>
            <MobileShare mb={2} {...commonProps}>
              <ButtonText>More app options</ButtonText>
            </MobileShare>
          </>
        )}
      </Flex>
    </>
  );
}
